/**
 * 🧹 TEXT UTILITIES
 * Sanitize and format wisdom transmissions.
 */

export function stripHtml(html) {
  if (!html) return "";
  
  // 1. Strip all HTML tags
  let text = html.replace(/<[^>]*>?/gm, " ");

  // 2. Decode entities (Double pass to catch &amp;nbsp; → &nbsp; → " ")
  const decode = (str) => {
    return str
      .replace(/&nbsp;|&#160;/gi, " ")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#x27;|&#39;/g, "'");
  };

  text = decode(decode(text));

  // 3. Clean up whitespace
  return text.replace(/\s+/g, " ").trim();
}

/**
 * Truncate text with ellipsis
 */
export function truncate(text, length = 150) {
  if (!text || text.length <= length) return text;
  return text.substring(0, length) + "...";
}
